import React from 'react';

import { Icon } from '@rbilabs/universal-components';
import { HorizontalPosition } from 'features/content/components/typography-block';
import { StyleSheet } from 'react-native';

import { MarketingBasicTile } from 'components/marketing-basic-tile';
import { Box, BoxProps } from 'components/ui';
import { primitive, spacing } from 'styles/constants';

type InRestaurantRedemptionEntryContainerProps = BoxProps & {
  newUI?: boolean;
};

type InRestaurantRedemptionListProps = BoxProps & {
  loyaltyEmptyCartTileWidget?: unknown;
};

const styles = StyleSheet.create({
  inRestaurantRedemptionEntryContainer: {
    borderColor: primitive.$greyFive,
    borderStyle: 'solid',
    borderTopWidth: 1,
  },
  inRestaurantRedemptionEntryContainerNewUI: {
    borderRadius: primitive.$borderRadius,
    borderWidth: 1,
    marginBottom: spacing.$2,
    marginHorizontal: spacing.$4,
  },
  inRestaurantRedemptionEntryContent: {
    alignItems: 'center',
    flexDirection: 'row',
    paddingHorizontal: spacing.$0_5,
    paddingVertical: spacing.$3_5,
    width: '100%',
  },
  inRestaurantRedemptionList: {
    borderRadius: 12,
    margin: spacing.$4,
    overflow: 'hidden',
    padding: spacing.$0,
  },
  pictureAndDetails: {
    flex: 1,
    flexDirection: 'row',
  },
  rewardDetails: {
    flex: 1,
    justifyContent: 'center',
    marginLeft: spacing.$4,
    marginRight: spacing.$2,
  },
  wrapperName: {
    marginBottom: spacing.$2,
    width: '100%',
  },
});

export const InRestaurantRedemptionEntryContainer = ({
  newUI,
  style,
  ...props
}: InRestaurantRedemptionEntryContainerProps) =>
  React.createElement(Box, {
    ...props,
    style: [
      styles.inRestaurantRedemptionEntryContainer,
      newUI && styles.inRestaurantRedemptionEntryContainerNewUI,
      style,
    ],
  });

export const InRestaurantRedemptionEntryContent = ({ style, ...props }: BoxProps) =>
  React.createElement(Box, {
    ...props,
    style: [styles.inRestaurantRedemptionEntryContent, style],
  });

export const InRestaurantRedemptionList = ({
  loyaltyEmptyCartTileWidget: _loyaltyEmptyCartTileWidget,
  style,
  ...props
}: InRestaurantRedemptionListProps) =>
  React.createElement(Box, { ...props, style: [styles.inRestaurantRedemptionList, style] });

export const PictureAndDetails = ({ style, ...props }: BoxProps) =>
  React.createElement(Box, { ...props, style: [styles.pictureAndDetails, style] });

export const RewardDetails = ({ style, ...props }: BoxProps) =>
  React.createElement(Box, { ...props, style: [styles.rewardDetails, style] });

export const WrapperName = ({ style, ...props }: BoxProps) =>
  React.createElement(Box, { ...props, style: [styles.wrapperName, style] });

export const StyledIconX = Icon.withConfig({
  variant: 'cancel',
  color: primitive.$bbqBrown,
  size: 'xs',
  marginLeft: '$2',
});

export const EmptyCartWidgetStyled = MarketingBasicTile.withConfig({
  padding: '$4',
  backgroundColor: primitive.$mayoEggWhite,
  borderRadius: primitive.$borderRadius,
  marginY: '$2',
  marginX: '$4',

  _basicTileTitle: {
    color: primitive.$bbqBrown,
    fontSize: 'lg',
    lineHeight: '2xs',
    textAlign: 'center',
  },
  _typographyBlock: {
    horizontalPosition: HorizontalPosition.CENTER,
    color: primitive.$bbqBrown,
    lineHeight: 'md',
    fontSize: 'md',
    marginY: '$4',
  },
});
